<template>
  <div id="navbar-area" class="navbar-area sticky-top">

    <div class="mobile-nav">
      <router-link :to="'/home'" class="navbar-brand">
        <img src="/assets/img/logo.png" class="logo" alt="Logo">
      </router-link>
    </div>
    <div class="main-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <router-link :to="'/home'" class="navbar-brand">
            <img src="/assets/img/logo.png" class="logo" alt="Logo">
          </router-link>

          <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">

            <ul class="navbar-nav" :style="'opacity:' + parseInt(!pgLoading)">
              <li class="nav-item">
                <router-link :to="'/home'" :class="(this.$route.path == '/home') ? 'active' : ''">
                  {{ $t('app.home') }}
                </router-link>
              </li>

              <li class="nav-item" v-for="(item, idx) in items" :key="idx">
                <router-link :to="'/' + item.slug" class="nav-link"
                  :class="$route.path.includes(item.en.title) ? 'active' : ''">
                  {{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}
                </router-link>
              </li>
            </ul>

            <div class="side-nav">
              <a class="phone-link" @click.prevent="toWhatsApp()">
                <i class="icofont-whatsapp"></i> +96592244785
              </a>
            </div>

          </div>
        </nav>
      </div>
    </div>


  </div>
</template>

<script>

import '@/plugins/jquery-1.12.4.min.js';
import '@/plugins/jquery.meanmenu.js';


export default {
  name: 'Header',
  components: {},
  data() {
    return {
      //
      items: [],
      refs: 'pages',
      settings: {
        en: {
          phone: ''
        },
        ar: {
          phone: ''
        }
      },
      pgLoading: false,
    }
  },
  created() {
    //
    if (localStorage.getItem('settings.phone')) {
      this.settings.phone = localStorage.getItem('settings.phone');
    }
    if (localStorage.getItem('settings.phone')) {
      this.settings.phone = localStorage.getItem('settings.phone');
    }

    this.fetchData();
  },
  methods: {
    //
    toWhatsApp() {
      const phone = +96592244785;
      window.open(
        "https://wa.me/" + phone + "?text=" + (this.$i18n.locale == 'ar' ? "مرحباً بك في تحصيل اكسبرس، كيف يمكنني مساعدتك؟" : "Welcome to 2PayMe, How can i help you?"),
        "_blank"
      );
    },
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/' + this.refs,
        method: 'GET',
        data: {},
        params: {
          ShowInHeader: true
        },
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.items = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
          window.$(".mean-menu").meanmenu({ meanScreenWidth: "991" });
          if (localStorage.getItem('locale') == 'ar') {
            document.getElementById("navbar-area").classList.add('is-rtl');
          }
        });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.phone-link{
  cursor: pointer;
}
</style>